import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-4b425100"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "key-field" }
const _hoisted_2 = {
  key: 0,
  class: "value-null"
}
const _hoisted_3 = {
  key: 1,
  class: "value-field"
}

import { useDevice } from '../composables'
import { format } from 'date-fns'
import yaml from 'js-yaml'


export default /*#__PURE__*/_defineComponent({
  __name: 'DeviceDetailsTable',
  props: {
    group: {},
    groupName: {}
  },
  setup(__props: any) {

const props = __props;

const { deviceConfig } = useDevice()


function formatValue(value: any, key: string): string {
  const type = deviceConfig[props.groupName][key]

  if (type === 'date') return format(new Date(value), 'dd-MM-yy HH:mm:ss')
  if (type === 'id') return value.split('/')[3]
  if (type === 'boolean') return value === true ? 'Yes' : 'No'
  if (type === 'json') return yaml.dump(value)

  return value
}

function formatKey(key: string) {
  const result = key.replace(/([A-Z])/g, ' $1')
  return result.charAt(0).toUpperCase() + result.slice(1).toLowerCase()
}

return (_ctx: any,_cache: any) => {
  const _component_PrimeColumn = _resolveComponent("PrimeColumn")!
  const _component_DataTable = _resolveComponent("DataTable")!

  return (_openBlock(), _createBlock(_component_DataTable, {
    value: _ctx.group,
    class: "table-padding",
    "selection-mode": "single"
  }, {
    default: _withCtx(() => [
      _createVNode(_component_PrimeColumn, {
        field: "key",
        "header-style": "display:none;",
        style: {"width":"30%","vertical-align":"baseline","background-color":"#f9f9f9"}
      }, {
        body: _withCtx(({ data: { key } }) => [
          _createElementVNode("span", _hoisted_1, _toDisplayString(formatKey(key)), 1)
        ]),
        _: 1
      }),
      _createVNode(_component_PrimeColumn, {
        field: "value",
        style: {"width":"70%"},
        "header-style": "display:none;"
      }, {
        body: _withCtx(({ data: { key, value } }) => [
          (value == null)
            ? (_openBlock(), _createElementBlock("span", _hoisted_2, " null "))
            : (_openBlock(), _createElementBlock("span", _hoisted_3, _toDisplayString(formatValue(value, key)), 1))
        ]),
        _: 1
      })
    ]),
    _: 1
  }, 8, ["value"]))
}
}

})